module.exports = __webpack_public_path__ + "assets/HKNova-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Light.woff
// module id = 139
// module chunks = 0